export default function InternalLinks() {
  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Autres prestations
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-8 leading-tight">
            Vous cherchez aussi une <span className="font-serif italic">autre réparation</span> ?
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <a
              href="/reglage-fenetre-oscillo-battant"
              className="bg-white rounded-2xl border border-rose-200 p-6 md:p-8 hover:border-coral transition-colors group"
            >
              <div className="w-10 h-10 rounded-lg bg-rose-50 flex items-center justify-center mb-4 group-hover:bg-coral/10 transition-colors">
                <i className="ri-settings-3-line text-plum group-hover:text-coral transition-colors" />
              </div>
              <h3 className="font-semibold text-plum text-sm md:text-base mb-2">
                Réglage oscillo-battant
              </h3>
              <p className="text-sm text-plum-dark/70">
                Fenêtre qui frotte ou ferme mal ? Réglage précis du mécanisme chez vous.
              </p>
              <div className="mt-4 flex items-center gap-1 text-coral text-sm font-medium">
                <span>Découvrir</span>
                <i className="ri-arrow-right-line" />
              </div>
            </a>
            <a
              href="/fenetre-oscillo-battant-bloquee"
              className="bg-white rounded-2xl border border-rose-200 p-6 md:p-8 hover:border-coral transition-colors group"
            >
              <div className="w-10 h-10 rounded-lg bg-rose-50 flex items-center justify-center mb-4 group-hover:bg-coral/10 transition-colors">
                <i className="ri-lock-unlock-line text-plum group-hover:text-coral transition-colors" />
              </div>
              <h3 className="font-semibold text-plum text-sm md:text-base mb-2">
                Oscillo-battant bloquée
              </h3>
              <p className="text-sm text-plum-dark/70">
                Fenêtre coincée en position inclinée ? Déblocage rapide à domicile.
              </p>
              <div className="mt-4 flex items-center gap-1 text-coral text-sm font-medium">
                <span>Découvrir</span>
                <i className="ri-arrow-right-line" />
              </div>
            </a>
            <a
              href="/zones"
              className="bg-white rounded-2xl border border-rose-200 p-6 md:p-8 hover:border-coral transition-colors group"
            >
              <div className="w-10 h-10 rounded-lg bg-rose-50 flex items-center justify-center mb-4 group-hover:bg-coral/10 transition-colors">
                <i className="ri-map-pin-line text-plum group-hover:text-coral transition-colors" />
              </div>
              <h3 className="font-semibold text-plum text-sm md:text-base mb-2">
                Zones d'intervention
              </h3>
              <p className="text-sm text-plum-dark/70">
                Strasbourg, Haguenau, Schiltigheim, Illkirch, Sélestat et tout le Bas-Rhin.
              </p>
              <div className="mt-4 flex items-center gap-1 text-coral text-sm font-medium">
                <span>Découvrir</span>
                <i className="ri-arrow-right-line" />
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}